import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import { WarningToast } from "../../ToastComponent/RectHotToast";
import { BankConfig, CashConfig, DocUpload, Voucherfilds } from "../AddBankPayment/AddBankPayment.config";
import AddPaymentSection from "../AddBankPayment/AddBankPaymentSection/AddBankPaymentSection";

import { Addition, Subtraction } from "../../../../CommonFunction/CalculationsWithDecimalValues";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { isEmpty } from "../../../../CommonFunction/GetUserInfo";
import { IsoToDateWithoutTime, convertToISO } from "../../../../CommonFunction/IsoDateTime";
import TransactionCheck from "../../../../CommonFunction/TransactionCheck";
import {
  CreateVoucher,
  DELETE_Voucher_MUTATION,
  Edit_Voucher_Que,
  LOCK_VOUCHER,
  transactionData,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { initialState } from "../AddBankPayment/AddBankPayment";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { Confirm } from "../../Confirmation/Confirm";
import { useModalContext } from "../../Reactportal/ModalContext";
const AddCashPayment = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction, setOpen }) => {
  let formRef = useRef({});
  const Form_Key = "Cash_Payment";
  const { pushModal, popModal } = useModalContext();
  const [isFirstLoad, setFirstLoad] = useState(false);
  const BookingkeyName = useSelector((store) => store?.BookingBrokerVoucherData?.currentKey);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Cash_Payment?.Selected_Row || fielddataRedux?.Account_Vouchers?.Selected_Row || fielddataRedux?.Transaction_Checks?.Selected_Row;
  const tableData = useSelector((store) => store.TableDataReducer.tableData);
  const [fileData, setFileData] = useState({});
  const [data, setData] = useState();
  const [TrasactionData, setTrasactionData] = useState([]);
  const [toggle, settoggle] = useState(show ? show : false);
  const [alldata, setalldata] = useState({});
  const [allFieldsData, setAllFieldsData] = useState({});
  const [notedata, setNotesdata] = useState(fielddata && TypeOfPortal !== "Add" ? fielddata.Narration : "");
  const [VoucherData, SetVoucherData] = useState({
    Date: "",
    Ref_No: "",
    User_Reference_Number: "",
  });
  const [TypeofFilds, setTypeofFilds] = useState(CashConfig);
  const [createCashPayment, { loading: createCashPaymentLoading }] = useMutation(CreateVoucher);
  const [selectedRows, setSelectedRows] = useState([]);

  const [deleteCashPayment, { loading: deleteBankPaymentLoading }] = useMutation(DELETE_Voucher_MUTATION);

  const [Voucher_Type, setVoucher] = useState("Payment");
  const [account, setAccount] = useState("Cash");
  const [Entry_Type, setEntryType] = useState(account + " " + Voucher_Type);

  const [Edit_Cash_Payment, { loading: Edit_Cash_RecieptLoading }] = useMutation(Edit_Voucher_Que);
  const [lockTheEntry, { loading: lockCashPaymentLoading }] = useMutation(LOCK_VOUCHER);
  const [CrSum, setCrSum] = useState(0);
  const [DrSum, setDrSum] = useState(0);
  const [GetTransactionData, { loading: GetTransactionDataLoader }] = useLazyQuery(transactionData, {
    fetchPolicy: "network-only",
  });
  const CashPaymentLoadingState =
    createCashPaymentLoading || deleteBankPaymentLoading || Edit_Cash_RecieptLoading || GetTransactionDataLoader;
  const [tablerow, settableRow] = useState([...initialState]);

  const dispatch = useDispatch();

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    if (
      !isEmpty(fielddata) &&
      TypeOfPortal !== "Add" &&
      TypeOfPortal !== "Delete" &&
      (fielddata["_id"] || fielddata["id"] || fielddata["Voucher_Id"])
    ) {
      setNotesdata(fielddata.Narration);
      GetTransactionData({
        variables: {
          id: fielddata && TypeOfPortal !== "Add" ? fielddata["Voucher_Id"] || fielddata["_id"] || fielddata["id"] : "",
        },
      })
        .then((res) => {
          setData(res?.data);
          let VoucherData = {
            ...res?.data?.GetVoucherEntriesWithTransactions[0],
          };
          if (VoucherData.Date) {
            let Date = IsoToDateWithoutTime(VoucherData.Date);
            SetVoucherData((prev) => {
              return {
                ...prev,
                Date: Date,
                Ref_No: VoucherData?.Ref_No,
                User_Reference_Number: VoucherData?.User_Reference_Number,
              };
            });
            setNotesdata(VoucherData.Narration);
            VoucherData.Date = Date;
          }
          console.log(VoucherData);
          setAllFieldsData(VoucherData);
        })
        .catch((err) => console.log(err?.message));
    } else {
      setAllFieldsData({ Date: GetTodaysDateINdmy() });
      SetVoucherData((prev) => {
        return { ...prev, Date: GetTodaysDateINdmy() };
      });
      setNotesdata("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata, TypeOfPortal]);
  useEffect(() => {
    if (data && data.GetVoucherEntriesWithTransactions) {
      let tr = data.GetVoucherEntriesWithTransactions[0].Transactions;
      let arr = tr?.map((el, i) => {
        let { Account } = el;
        let { AccountData } = Account;
        let name;
        if (AccountData && AccountData.Business_Name) {
          name = AccountData.Business_Name;
        } else if (AccountData && AccountData.Proprietor_Name) {
          name = AccountData.Proprietor_Name;
        } else if (AccountData && AccountData.BankAccount_Name) {
          name = AccountData.BankAccount_Name;
        } else if (AccountData && AccountData.Name) {
          name = AccountData.Name;
        } else if (AccountData && AccountData.Alternate_Name) {
          name = AccountData.Alternate_Name;
        }
        let key = i === 0 ? "Account_Name1" : `Account_Name${Math.random() * 10}`;
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              [key]: {
                Account_Balance_Id: el.Account_ID,
                _id: el.Account_ID,
                AccountData: { Balance_Method: AccountData?.Balance_Method },
                Balance_Method: AccountData?.Balance_Method,
              },
            },
          },
        });
        return {
          Account_ID: el.Account_ID,
          Transaction_Type: el.Transaction_Type,
          Amount: el.Amount,
          id: el._id,
          [key]: name,
          name: key,
        };
      });

      let length = arr.length;

      if (arr.length > 0) {
        for (let i = length; i < 4; i++) {
          let key = `Account_Name${Math.random() * 10}`;
          let obj = {
            id: Math.random() * 10,
            Transaction_Type: "Credit",
            Account_ID: "",
            Amount: "",
            [key]: "",
            name: key,
          };
          arr.push(obj);
        }
        setTrasactionData(arr);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    setDrSum(0);
    setCrSum(0);
    if (tablerow.length !== 0) {
      tablerow.forEach((el) => {
        if (el.Transaction_Type === "Credit") {
          if (el.Amount !== "") {
            setCrSum((prev) => Addition(prev, Number(el.Amount)));
          }
        }
        if (el.Transaction_Type === "Debit") {
          if (el.Amount !== "") {
            setDrSum((prev) => Addition(prev, Number(el.Amount)));
          }
        }
      });
    }
  }, [TrasactionData, tablerow]);
  useEffect(() => {
    if (TrasactionData.length !== 0) {
      settableRow(TrasactionData);
    }
  }, [TrasactionData]);

  const SetData = (event) => {
    SetVoucherData((prev) => {
      return { ...prev, [event.target.name]: event?.target?.value };
    });
  };

  useEffect(() => {
    setEntryType(account + " " + Voucher_Type);
  }, [account, Voucher_Type]);

  useEffect(() => {
    if (FormDataFromRedux && FormDataFromRedux.hasOwnProperty(Form_Key)) {
      setalldata(FormDataFromRedux[Form_Key]);
    }
  }, [FormDataFromRedux]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Cash_Payment?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);
  formRef.current.GetFileValues = (values) => {
    console.log(values);
    setFileData((prev) => {
      return { ...prev, ...values };
    });
  };
  const InputOnFocus = (el, index) => {
    let transactionArray = [...tablerow];

    let diff = 0;
    let updatedData = transactionArray.map((element, i) => {
      if (i > index) {
        if (diff < 0) {
          let obj = {
            ...element,
            Amount: diff * -1,
            Transaction_Type: "Credit",
          };
          diff = 0;
          return obj;
        } else {
          let obj = { ...element, Amount: diff, Transaction_Type: "Debit" };
          diff = 0;
          return obj;
        }
      }

      if (element.Transaction_Type === "Debit") {
        // diff = diff - Number(element.Amount);
        diff = Subtraction(diff, Number(element.Amount));
      } else {
        // diff = diff + Number(element.Amount);
        diff = Addition(diff, Number(element.Amount));
      }
      return element;
    });
    settableRow(updatedData);
  };
  const onTransactionChange = (e, name, id) => {
    let transactionArray = [...tablerow];
    let key = name;
    let value = e.target.value;
    if (value !== undefined) {
      let updatedData = transactionArray.map((el, i) => {
        if (el.id === id) {
          return { ...el, [key]: value };
        } else {
          return el;
        }
      });
      settableRow(updatedData);
    }
  };
  const submit = async (close) => {
    let data = {};
    if (TypeOfPortal !== "Delete") {
      for (let key in alldata) {
        data = {
          ...data,
          ...alldata[key],
        };
      }
      console.log(data);
      data = {
        ...data,
        Entry_Type,
        Account_Type: account,
        Voucher_Type: Voucher_Type,
        Narration: notedata,
        ...fileData,
        Ref_No: VoucherData?.Ref_No,
        User_Reference_Number: VoucherData?.User_Reference_Number,
        Date: VoucherData?.Date || "",
      };
      let BankAccount = FormDataFromRedux?.MasterData[Form_Key]?.Account_Name1?._id;
      if (!BankAccount) {
        WarningToast(`${data.Account_Type} Account Should Be Involve in Transaction...!`);
        return;
      }
      if (!tablerow[0]?.Amount) {
        WarningToast(`${data.Account_Type} Account Should Be Involve in Transaction...! Enter Amount`);
        return;
      }
      delete data.Account_ID;
      delete data.Amount;
      delete data.Account_Name;
      delete data?.Material_Dimension_In;
      delete data?.Material_Dimension;
    }

    let Mutation =
      TypeOfPortal === "Add" || TypeOfPortal === "Copy"
        ? createCashPayment
        : TypeOfPortal === "Edit"
          ? Edit_Cash_Payment
          : TypeOfPortal === "Delete"
            ? deleteCashPayment
            : TypeOfPortal === "Lock" || TypeOfPortal === "Unlock"
              ? lockTheEntry
              : "";
    TransactionCheck(
      tablerow,
      TypeOfPortal,
      Closeformfunction,
      settableRow,
      settoggle,
      toggle,
      setNotesdata,
      setAllFieldsData,
      close,
      data,
      allFieldsData,
      Mutation,
      selectedRows,
      dispatch,
      tableData,
      FormDataFromRedux,
      Form_Key,
      BookingkeyName,
      initialState
    );
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    dispatch({ type: "CleartableData", payload: {} });
    ClearSpecificForm(dispatch, Form_Key);
    settableRow([...initialState]);
    setNotesdata("");
    if (setOpen) {
      setOpen(false);
    }
  };

  const handleVoucherChange = (e) => {
    setVoucher(e.target.value);
    let arr = [...tablerow];
    if (e.target.value === "Payment") {
      arr[0] = { ...arr[0], Transaction_Type: "Credit" };
      arr[1] = { ...arr[1], Transaction_Type: "Debit" };

      settableRow(arr);
    } else if (e.target.value === "Receipt") {
      arr[0] = { ...arr[0], Transaction_Type: "Debit" };
      arr[1] = { ...arr[1], Transaction_Type: "Credit" };

      settableRow(arr);
    }
  };

  const SaveAndClose = () => {
    submit();
  };
  const SaveAndCloseForAdd = () => {
    submit("Close");
  };
  const handleAccount = (e) => {
    setAccount(e.target.value);
    if (e.target.value === "Bank") {
      setTypeofFilds(BankConfig);
    } else {
      setTypeofFilds(CashConfig);
    }
  };
  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={submit}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={lockCashPaymentLoading}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }
  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}

          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={CashPaymentLoadingState}
        />
      </Reactportal>
    );
  }
  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={submit}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      submitType={BookingkeyName ? "" : submitType}
      SaveAndClose={TypeOfPortal === "Add" ? SaveAndCloseForAdd : SaveAndClose}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={CashPaymentLoadingState}
    />
  );
  return (
    <div>
      {" "}
      <div
        style={{
          display: id ? "none" : "block",
        }}
        onClick={() => {
          settoggle(!toggle);
        }}
      ></div>
      <Reactportal
        FoooterContent={footerContent}
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={TypeOfPortal + " " + account + " " + Voucher_Type}
        id={allFieldsData && allFieldsData?.id ? allFieldsData?.id : id}
      >
        {CashPaymentLoadingState && <div className="loader-line-div" />}
        <div className="paymentMainContainer">
          <div className="paymentContainer">
            <div className="paymentHeader">
              <div className="paymentHeader2">
                {TypeofFilds.map((e, i) => {
                  return (
                    <>
                      <AddPaymentSection
                        inputfields={e.fields}
                        Type={e.name}
                        fielddata={allFieldsData}
                        TypeOfPortal={TypeOfPortal}
                        Bank_Fields={TypeofFilds}
                        type={Voucher_Type}
                        name={e.name}
                        TypeofFilds={TypeofFilds}
                        voucher={Voucher_Type}
                        Account={account}
                        handleVoucherChange={handleVoucherChange}
                        handleAccount={handleAccount}
                        el={tablerow[0]}
                        index={i}
                        onTransactionChange={onTransactionChange}
                        // classname="HeaderSectionDiv"
                        setData={SetData}
                        InputOnFocus={InputOnFocus}
                        VoucherData={VoucherData}
                        formkey={Form_Key}
                        setFirstLoad={setFirstLoad}
                      />
                    </>
                  );
                })}
              </div>
            </div>

            <hr></hr>
            {Voucherfilds?.map((e, i) => {
              return (
                <>
                  <AddPaymentSection
                    inputfields={e.fields}
                    Type={e.name}
                    fielddata={allFieldsData}
                    TypeOfPortal={TypeOfPortal}
                    Bank_Fields={TypeofFilds}
                    type={Voucher_Type}
                    name={e.name}
                    TypeofFilds={TypeofFilds}
                    el={tablerow[i + 1]}
                    onTransactionChange={onTransactionChange}
                    InputOnFocus={InputOnFocus}
                    index={i + 1}
                    formkey={Form_Key}
                  />
                </>
              );
            })}
          </div>
          <div className="NoteImageHeading">
            <div>
              <p className="NoteLable">Notes: </p>
            </div>
            <div>
              <p className="NoteLable">Documents: </p>
            </div>
          </div>

          <div className="AddBankPaymentNoteAndImages">
            <div className="NoteAndImages">
              <div className="moredetailsection">
                {/* <div className="note"> */}
                <textarea
                  name="note"
                  value={notedata}
                  placeholder="Please Enter Notes"
                  onChange={(e) => setNotesdata(e.target.value)}
                ></textarea>
                {/* </div> */}
              </div>
              <div className="loadImages">
                <DocumentuploadSection
                  data={DocUpload.fields}
                  TypeOfPortal={TypeOfPortal}
                  LoadForm={true}
                  formkey={Form_Key}
                  values={allFieldsData}
                  formReference={formRef}
                />
              </div>
            </div>
          </div>
        </div>
      </Reactportal>
    </div>
  );
};

export default AddCashPayment;
